import $ from "jquery"
import "slick-carousel-latest"
import "jquery-match-height";

// Reviews Slider
$('.js-reviews-lists').on('init', function(event, slick) {
    $('.js-reviews-matchheight').matchHeight();
    $('.js-reviews-count-current').text(slick.currentSlide + 1);
});

$('.js-reviews-lists').on('afterChange', function(event, slick) {
    $('.js-reviews-matchheight').matchHeight();
    $('.js-reviews-count-current').text(slick.currentSlide + 1);
});

$('.js-reviews-lists').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '.reviews__count-nav--prev',
    nextArrow: '.reviews__count-nav--next',
    centerMode: true,
    centerPadding: '15px',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {  breakpoint: 992,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});